import { createAction } from 'redux-actions';
import { SET_SWEETALERT } from '../constants/set';
export const setSweetAlert = createAction(SET_SWEETALERT, (u) => u);